import React, { useEffect } from 'react';
import './Notification.css';

function Notification({ message, type, onClose, id }) {
  const durationMs = (type === 'warning' || type === 'danger' || type === 'error') ? 4000 : 2000;

  const renderNotificationIcon = (notificationType) => {
    const commonProps = { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'currentColor', 'aria-hidden': true };
    switch (notificationType) {
      case 'success':
        return (
          <svg {...commonProps}>
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm-1.003 14.003-3.5-3.5 1.414-1.414 2.086 2.086 4.586-4.586 1.414 1.414-6 6Z" />
          </svg>
        );
      case 'warning':
        return (
          <svg {...commonProps}>
            <path d="M12.865 3.515a1 1 0 0 0-1.73 0L2.21 18.01A1 1 0 0 0 3.075 19.5h17.85a1 1 0 0 0 .866-1.49L12.865 3.515ZM12 8a1 1 0 0 1 1 1l-.25 5a.75.75 0 0 1-1.5 0L11 9a1 1 0 0 1 1-1Zm0 10a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z" />
          </svg>
        );
      case 'danger':
      case 'error':
        return (
          <svg {...commonProps}>
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm3.536 12.121-1.415 1.415L12 13.415l-2.121 2.121-1.415-1.415L10.585 12 8.464 9.879l1.415-1.415L12 10.585l2.121-2.121 1.415 1.415L13.415 12l2.121 2.121Z" />
          </svg>
        );
      case 'info':
        return (
          <svg {...commonProps}>
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm.75 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM11 10h2v6h-2v-6Z" />
          </svg>
        );
      default:
        return (
          <svg {...commonProps}>
            <path d="M10 21h4v-2h-4v2ZM12 2a6 6 0 0 0-6 6h2a4 4 0 1 1 8 0h2a6 6 0 0 0-6-6Zm-7 8h14v2H5v-2Z" />
          </svg>
        );
    }
  };
  useEffect(() => {
    // Suppress auto-close timer for error alerts replaced by global modal
    if (type === 'error' || type === 'danger') {
      return;
    }
    const timer = setTimeout(() => {
      onClose();
    }, durationMs);
    return () => {
      clearTimeout(timer);
    };
  }, [onClose, durationMs, type]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  // Do not render toast for error/danger; handled by global modal in App
  if (type === 'error' || type === 'danger') {
    return null;
  }

  return (
    <div 
      className={`notification notification-${type}`}
      onClick={handleClick}
      onTouchEnd={handleClick}
      role="alert"
      style={{ cursor: 'pointer', ['--notif-duration']: `${durationMs}ms` }}
    >
      <span className="notification__icon" aria-hidden="true">
        {renderNotificationIcon(type)}
      </span>
      <span className="notification__message">{message}</span>
    </div>
  );
}

export default Notification;